module.exports = __webpack_public_path__ + "static/cube2-f4c28bac59f411fbde46471b5dfb21e8.svg";